module.exports = __webpack_public_path__ + "static/img/zj_teacher_info_widget_2.2a2bae0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/zj_teacher_info_widget_2.png
// module id = SF5K
// module chunks = 11